import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Athlete, AthleteWrite } from 'types';
import { client } from 'utils/api-client';

const updateSelfAthlete = (athlete: AthleteWrite): Promise<AxiosResponse<Athlete>> => {
  return client.put(`athletes/self/`, athlete);
};

export default function useUpdateSelfAthlete(): UseMutationResult<
  AxiosResponse<Athlete>,
  AxiosError<ErrorMessage>,
  AthleteWrite
> {
  const queryClient = useQueryClient();

  return useMutation(updateSelfAthlete, {
    onSuccess: () => {
      queryClient.invalidateQueries(['athletes']);
    },
  });
}
